var _circle, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47.5,
    r: 47.5,
    fill: "#E2FBE9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 23,
    width: 48,
    height: 48,
    fill: "url(#pattern0_336_2506)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_336_2506",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_336_2506",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_336_2506",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEj0lEQVR4nO1bTYgcVRB+iWzERfw7GEUC4kVUEHRP6upB4rpMVe+4U++5mwgKHhbEgIKKXnTEvzUnycHDuKarxo0gA+YiGMGL8QdRchBikBxEhCQeNOIvmGTZkerpWWd6eyaZP7tnpj9o2O6efq/r6/e+eq+q1pgMGTJkyJBh5OEqbhsK7UW2p0DoJLJ9Xa+ZcYEajGKrjQcILZtxQfDVxVZzPt2JZTcdEnDSjDLyvHA9+PQoCh2of/X6vej5SGD+nfmrga1DoRIIHYsO+ZEjIM/5K7wy5UHsPmD7LbJdbzKY7TlkOgji9owEAVjCSRSaUUEDsV8D01qzwfQXMP3YQMDhjWeHkYCp0tJEKFhFNQaYzjSpuJ6zPRzcL7tp/b2pmi3w7u4r9WhsaygIKBaLWz2hW0DcEoqtoNBvEYPXUOhIOOTd7OpDl11o26klAPYXbqgbDGx/iRGu7wNRY+tmVtxV3faTGgLyja6J7ak4g4FpxRPa5a0sbu+ocR3+TJ8h06/hcTBxAryVxe1qjBpV+5oRgwMS6ICSouT0OoVA7HeJimA+6po2fWE6XXdNc/vdzf3uPyDh/xRBLOEklAs7gelFZPsxCp1tXm/bv/U6CD27odQJoCUBrmGXhEI/6d/tXrIr15QCtCQAY3ZJyPbV5nnlppDdMyh0SBcbm1wT01cb10o4mZiV3YggxOySantmt0cbCBpqJmcd2R7VOa5zXed8XAdJoCsRxBY34lwTsF1s5ZrSQEBXIogtCejMNaWFgFbomADTYwdpw3gQUO1CBHGECOirCJohJKCvImiGlIBWyAiQAY8AUPER+6kZVxFMAxIVwbQgSRH8AsR+blKKTARlHNxgNVsJbs1WgsWEtsOQhnVAG3RBgI2Erm1FExh5f2GHGUKcNySGZTcNPt19ISExDXdHQ2KpQJcxweXoFwehVzoJimqmthZcpZkkg6JdrQRdxW1TEsLCIS0gWm4XyvaEbg014jQwfYJi/0lTWHzgiREQ90TI7qqeu4q7ZKgTI50C2H4QGvZw3H1XcZcqIeGUOBKt2gCmP+uE6NTSeWuGhYCp0tIEiP2jRoC7Lm3J0YFnh7Hs7ghF8lhP6XGml2PdbY/p8YFnhyHI6wfD+L2OHoy2w/apsB0/V164CZkeR7HvB5njHl3uQEXQE9oVeoBDpgcg24+Cdny3O/ry6M/fjkJPA9sP++ly+0JA3l/YEbwE05m5Mt1musDsvtmLQ8+wrnV97X67kYlm90KvLrdvXgDFvhV2/jOwffL+1flrO3ne8929YeffdNx3CSc9393XtkxOCyQHWSKDWhChw7N5rh5FoTdy7EDdYNvn2Uo4jfaaPlajBO+w2eWuDaZQsmq2eEIP6pog8OtNKk5nw8KJ59VruIq7qGFJ/Vjtpey5ubfdjabPOK/LHUTsc6q0NJGTwj0o9iUQ+2XMsPw9XBD9VxHG7jkzqsXSO0vucuTCA8D0JjIdj2yyfoAyPWISQPyul04MvOMcu2s8Ltyl/l6ngUkIcbteZHrNjAuad710Qo134/QvMxkyZMiQwWzGv6uU8NCH8VqwAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketIcon);
export default __webpack_public_path__ + "static/media/marketIcon.e06aa529f400fd59cd18dd18544cd19f.svg";
export { ForwardRef as ReactComponent };